import React, { useState, useEffect } from 'react';
import { contact } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-content">
        <div className="logo">
          <svg width="50" height="38" viewBox="0 0 194 145" fill="none">
            <path d="M144.477 47.5932C140.209 40.7414 134.26 35.0943 127.195 31.1883C120.131 27.2823 112.185 25.247 104.112 25.2757C77.9063 25.2757 56.6304 46.4267 56.6304 72.4939C56.6304 98.5611 77.9063 119.712 104.112 119.712C112.869 119.72 121.457 117.305 128.926 112.735C136.396 108.165 142.455 101.618 146.435 93.8185H121.875C115.69 93.8333 109.752 91.3923 105.366 87.032C100.979 82.6716 98.503 76.7484 98.481 70.5635H176.863V72.5078C176.852 86.4051 172.832 100.004 165.284 111.673C157.736 123.342 146.982 132.585 134.311 138.294H134.228C134.152 138.294 134.075 138.37 133.999 138.37C84.003 160.146 20.4181 110.998 0.621204 144.752C-4.30199 59.1756 58.7413 15.7834 58.7413 15.7834C73.5006 4.09321 92.2043 -1.44551 110.949 0.323137C129.694 2.09179 147.032 11.0312 159.344 25.2757C171.78 12.8323 172.641 0.236135 172.641 0.236135C172.641 0.236135 188.362 1.31938 193.917 8.70764C177.648 40.1286 144.477 47.5932 144.477 47.5932Z" fill="url(#paint0_linear)"/>
            <defs>
              <linearGradient id="paint0_linear" x1="0" y1="80.5" x2="194" y2="79.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FA6030"/>
                <stop offset="1" stopColor="#FFC876"/>
              </linearGradient>
            </defs>
          </svg>
          <div className="logo-text">
            <span className="logo-main">GPO</span>
            <span className="logo-sub">GREEN POWER ORIENTED</span>
          </div>
        </div>

        <nav className="nav">
          <a href="#about" className="nav-link">{t(translations.nav.about)}</a>
          <a href="#products" className="nav-link">{t(translations.nav.products)}</a>
          <a href="#features" className="nav-link">{t(translations.nav.features)}</a>
          <a href="#gallery" className="nav-link">{t(translations.nav.gallery)}</a>
          <a href="#contact" className="nav-link">{t(translations.nav.contact)}</a>
        </nav>

        <a href={`tel:${contact.phone}`} className="phone-link-header">
          <span className="phone-icon">{'\u{1F4DE}'}</span>
          <span className="phone-number">{contact.phone}</span>
        </a>

        <a href="#contact" className="btn btn-primary btn-header">
          {t(translations.nav.consultation)}
        </a>
      </div>
    </header>
  );
}

export default Header;
